import { Dialog, useTheme } from "@mui/material";
import * as React from "react";

import styles from "./ChatSidebar.module.css";
import { ChatSidebarControls } from "./ChatSidebarControls";
import { ChatSidebarMainContent } from "./ChatSidebarMainContent";

interface ChatFullscreenModalProps {
  open: boolean;
  onClose: () => void;
}

export const ChatFullscreenModal: React.FC<ChatFullscreenModalProps> = ({
  open,
  onClose,
}) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen
      sx={{
        zIndex: theme.zLayer(10),
      }}
    >
      <div className={styles.container}>
        <ChatSidebarControls onClose={onClose} />

        <ChatSidebarMainContent />
      </div>
    </Dialog>
  );
};
